import _extends from '@babel/runtime/helpers/esm/extends';
import _defineProperty from '@babel/runtime/helpers/esm/defineProperty';
import _objectWithoutProperties from '@babel/runtime/helpers/esm/objectWithoutProperties';
import React, { forwardRef } from 'react';
import { LoadingSpinner } from '@swift-paypal/pp-react-loading-spinner';
import { V2CheckmarkIcon, CheckAltIcon } from '@swift-paypal/pp-react-icons';
import { useTheme } from '@swift-paypal/pp-react-theme';
import clsx from 'clsx';
import '../__generated__/styles/button.css';

var styles = {"ppvx_btn":"ppvx_btn___5-10-8","ppvx_btn--inverse":"ppvx_btn--inverse___5-10-8","ppvx_btn--secondary":"ppvx_btn--secondary___5-10-8","ppvx_btn--branded":"ppvx_btn--branded___5-10-8","ppvx_btn--icon":"ppvx_btn--icon___5-10-8","ppvx_btn--size_sm":"ppvx_btn--size_sm___5-10-8","ppvx_btn--size_md":"ppvx_btn--size_md___5-10-8","ppvx_btn--tertiary":"ppvx_btn--tertiary___5-10-8","ppvx_btn__icon":"ppvx_btn__icon___5-10-8","ppvx_btn--state_success":"ppvx_btn--state_success___5-10-8","ppvx_btn--state_processing":"ppvx_btn--state_processing___5-10-8","ppvx_btn--state__screenreader":"ppvx_btn--state__screenreader___5-10-8","ppvx_btn--state__overlay":"ppvx_btn--state__overlay___5-10-8","fadeIn":"fadeIn___5-10-8","ppvx_btn--state__overlay--success":"ppvx_btn--state__overlay--success___5-10-8","ppvx_btn--state__success-icon":"ppvx_btn--state__success-icon___5-10-8","ppvx--v2":"ppvx--v2___5-10-8","ppvx--v1":"ppvx--v1___5-10-8","ppvx_btn--state__overlay--success-with-svg-icon":"ppvx_btn--state__overlay--success-with-svg-icon___5-10-8"};

var sizes = {
  md: styles['ppvx_btn--size_md'],
  sm: styles['ppvx_btn--size_sm'],
  lg: styles['ppvx_btn--size_lg']
};
var Button = forwardRef(function (_ref, ref) {
  var _clsx;

  var size = _ref.size,
      inverse = _ref.inverse,
      secondary = _ref.secondary,
      branded = _ref.branded,
      tertiary = _ref.tertiary,
      icon = _ref.icon,
      _ref$btnState = _ref.btnState,
      btnState = _ref$btnState === void 0 ? 'initial' : _ref$btnState,
      screenReaderText = _ref.screenReaderText,
      className = _ref.className,
      children = _ref.children,
      as = _ref.as,
      theme = _ref.theme,
      iconComponent = _ref.iconComponent,
      rest = _objectWithoutProperties(_ref, ["size", "inverse", "secondary", "branded", "tertiary", "icon", "btnState", "screenReaderText", "className", "children", "as", "theme", "iconComponent"]);

  // If theme is not directly provided, get from themeContext
  var _theme = useTheme('Button', theme);

  var isThemeV2 = _theme && _theme === 'v2';
  var loadingSpinnerProps = {};

  if (btnState === 'processing') {
    loadingSpinnerProps.as = 'span';

    if (size === 'sm') {
      loadingSpinnerProps.size = 'xs';
    }

    if (secondary && inverse || icon && inverse || !secondary && !icon && !inverse) {
      loadingSpinnerProps.inverse = true;
    }
  }

  var cls = clsx(!tertiary && styles.ppvx_btn, (_clsx = {}, _defineProperty(_clsx, sizes[size], size && size !== 'lg'), _defineProperty(_clsx, styles['ppvx_btn--inverse'], inverse), _defineProperty(_clsx, styles['ppvx_btn--secondary'], secondary), _defineProperty(_clsx, styles['ppvx_btn--icon'], icon), _defineProperty(_clsx, styles['ppvx_btn--branded'], branded), _defineProperty(_clsx, styles['ppvx_btn--tertiary'], tertiary), _clsx), _defineProperty({}, styles["ppvx_btn--state_".concat(btnState)], btnState !== 'initial'), isThemeV2 && styles['ppvx--v2'], className);
  return /*#__PURE__*/React.createElement(as || 'button', _extends({
    className: cls,
    "aria-live": "assertive",
    disabled: btnState && btnState !== 'initial',
    ref: ref
  }, rest), function renderChildren() {
    var overlayClasses;
    var srText;

    if (btnState !== 'initial') {
      overlayClasses = clsx(styles['ppvx_btn--state__overlay'], styles["ppvx_btn--state__overlay--".concat(btnState)], btnState === 'success' && styles['ppvx_btn--state__overlay--success-with-svg-icon']);
      srText = screenReaderText || btnState;
    }

    var srClass = styles["ppvx_btn--state__screenreader"];
    var successIconSize = size === 'sm' ? 'xs' : 'sm';
    var v2SuccessIconSize = size === 'sm' ? 'sm' : 'lg';
    var buttonCheckmarkIcon = isThemeV2 ? /*#__PURE__*/React.createElement(V2CheckmarkIcon, {
      className: styles['ppvx_btn--state__success-icon'],
      size: v2SuccessIconSize
    }) : /*#__PURE__*/React.createElement(CheckAltIcon, {
      className: styles['ppvx_btn--state__success-icon'],
      size: successIconSize
    });
    var svgIconSize = size === 'sm' ? 'xs' : 'sm';
    var svgIconClass = clsx([styles.ppvx_btn__icon]);
    return /*#__PURE__*/React.createElement(React.Fragment, null, iconComponent && /*#__PURE__*/React.createElement(iconComponent, {
      className: svgIconClass,
      size: svgIconSize
    }), children, btnState !== 'initial' && /*#__PURE__*/React.createElement("span", {
      className: overlayClasses
    }, btnState === 'success' && buttonCheckmarkIcon, btnState === 'processing' && /*#__PURE__*/React.createElement(LoadingSpinner, loadingSpinnerProps)), /*#__PURE__*/React.createElement("span", {
      className: srClass
    }, srText));
  }());
});

export { Button };
